
import { defineComponent, ref, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'

const tagAndTagSpacing = 4 // tagAndTagSpacing

export default defineComponent({
  name: 'ScrollPane',
  emits: ['scroll'],
  setup(props, { emit }) {
    const scrollContainer = ref<any>(null)
    const left = ref(0)
    
    const scrollWrapper = () => {
      return scrollContainer.value?.$el.querySelector('.el-scrollbar__wrap')
    }
    
    const handleScroll = (e: WheelEvent) => {
      const eventDelta = (e as any).wheelDelta || -e.deltaY * 40
      const $scrollWrapper = scrollWrapper()
      if ($scrollWrapper) {
        $scrollWrapper.scrollLeft = $scrollWrapper.scrollLeft + eventDelta / 4
      }
    }
    
    const emitScroll = () => {
      emit('scroll')
    }
    
    const moveToTarget = (currentTag: any) => {
      const $container = scrollContainer.value?.$el
      if (!$container) return
      
      const $containerWidth = $container.offsetWidth
      const $scrollWrapper = scrollWrapper()
      if (!$scrollWrapper) return
      
      const instance = getCurrentInstance()
      if (!instance?.parent) return
      
      const tagList = (instance.parent as any).$refs.tag as any[]
      
      let firstTag = null
      let lastTag = null
      
      // 查找第一个和最后一个标签
      if (tagList && tagList.length > 0) {
        firstTag = tagList[0]
        lastTag = tagList[tagList.length - 1]
      }
      
      if (firstTag === currentTag) {
        $scrollWrapper.scrollLeft = 0
      } else if (lastTag === currentTag) {
        $scrollWrapper.scrollLeft = $scrollWrapper.scrollWidth - $containerWidth
      } else {
        // 查找前一个和后一个标签
        const currentIndex = tagList.findIndex(item => item === currentTag)
        const prevTag = tagList[currentIndex - 1]
        const nextTag = tagList[currentIndex + 1]
        
        // 下一个标签的offsetLeft
        const afterNextTagOffsetLeft = nextTag.$el.offsetLeft + nextTag.$el.offsetWidth + tagAndTagSpacing
        
        // 前一个标签的offsetLeft
        const beforePrevTagOffsetLeft = prevTag.$el.offsetLeft - tagAndTagSpacing
        
        if (afterNextTagOffsetLeft > $scrollWrapper.scrollLeft + $containerWidth) {
          $scrollWrapper.scrollLeft = afterNextTagOffsetLeft - $containerWidth
        } else if (beforePrevTagOffsetLeft < $scrollWrapper.scrollLeft) {
          $scrollWrapper.scrollLeft = beforePrevTagOffsetLeft
        }
      }
    }
    
    onMounted(() => {
      const wrapper = scrollWrapper()
      if (wrapper) {
        wrapper.addEventListener('scroll', emitScroll, true)
      }
    })
    
    onBeforeUnmount(() => {
      const wrapper = scrollWrapper()
      if (wrapper) {
        wrapper.removeEventListener('scroll', emitScroll)
      }
    })
    
    return {
      scrollContainer,
      left,
      handleScroll,
      emitScroll,
      moveToTarget
    }
  }
})
